import { IconProps } from '@components/Icons/index';

const defaultSize = 48;

export const InfoSignIcon = ({ size, className }: IconProps) => {
  return (
    <svg
      className={className}
      width={size || defaultSize}
      height={size || defaultSize}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M36.6667 23.3337H43.3334V30.0003H36.6667V23.3337ZM36.6667 36.667H43.3334V56.667H36.6667V36.667ZM40.0001 6.66699C21.6001 6.66699 6.66675 21.6003 6.66675 40.0003C6.66675 58.4003 21.6001 73.3337 40.0001 73.3337C58.4001 73.3337 73.3334 58.4003 73.3334 40.0003C73.3334 21.6003 58.4001 6.66699 40.0001 6.66699ZM40.0001 66.667C25.3001 66.667 13.3334 54.7003 13.3334 40.0003C13.3334 25.3003 25.3001 13.3337 40.0001 13.3337C54.7001 13.3337 66.6668 25.3003 66.6668 40.0003C66.6668 54.7003 54.7001 66.667 40.0001 66.667Z"
        fill="#2E1A47"
      />
    </svg>
  );
};
